import { render, staticRenderFns } from "./chooseStudentInfo.vue?vue&type=template&id=5229e3d9&"
import script from "./chooseStudentInfo.vue?vue&type=script&lang=js&"
export * from "./chooseStudentInfo.vue?vue&type=script&lang=js&"
import style0 from "./chooseStudentInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports